<template>
  <div class="menu-wrapper border-r border-gainsboro flex flex-col">
    <div
      class="menu-logo-container border-b border-gainsboro flex flex-row items-center pl-4"
    >
      <BaseIcon class="mr-2" name="logo" width="28" height="32" />
      <div class="font-bold text-xs">Информирование граждан</div>
    </div>

    <div class="flex flex-col">
      <BaseLink
        v-for="(item, key) in menu"
        :key="key"
        class="menu-item flex flex-row items-center text-sm mt-4"
        :to="{name: item.link}"
      >
        <BaseIcon :name="item.icon" width="32" height="32" />
        <div class="ml-3">{{ item.title }}</div>
      </BaseLink>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  import BaseIcon from '@/components/global/base-icon';
  import BaseLink from '@/components/global/base-link';

  export default {
    name: 'MainMenu',

    components: {
      BaseIcon,
      BaseLink,
    },

    data() {
      return {
        userMenuItems: [
          {
            title: 'Информация',
            icon: 'book',
            link: 'info',
          },
          {
            title: 'Реестр ЛМСЗ для информирования',
            icon: 'organization',
            link: 'registry',
          },
          {
            title: 'Включение ЛМСЗ в жизненную ситуацию',
            icon: 'life',
            link: 'lmsp.request',
          },
          {
            title: 'Справочники',
            icon: 'house',
            link: 'dictionary',
          },
        ],
        headMenuItems: [
          {
            title: 'Информация',
            icon: 'book',
            link: 'info',
          },
          {
            title: 'Реестр ЛМСЗ для информирования',
            icon: 'organization',
            link: 'head.register',
          },
          {
            title: 'Справочники',
            icon: 'house',
            link: 'head.dictionary',
          },
        ],
        operatorMenuItems: [
          {
            title: 'Реестр ЛМСЗ для информирования',
            icon: 'organization',
            link: 'operator.register',
          },
          {
            title: 'Справочники',
            icon: 'house',
            link: 'operator.dictionary',
          },
        ],
      };
    },

    computed: {
      ...mapGetters('Auth', ['hasRole']),

      menu() {
        if (this.hasRole(['head'])) {
          return this.headMenuItems;
        } else if (this.hasRole(['operator'])) {
          return this.operatorMenuItems;
        } else {
          return this.userMenuItems;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .menu-wrapper {
    width: rem(280px);
    min-width: rem(280px);
  }
  .menu-logo-container {
    height: rem(64px);
  }
  .menu-item {
    padding-left: rem(16px);

    &.router-link-active {
      color: #000000;
      border-left: 4px solid #0061D9;
      padding-left: rem(16px - 4px);
    }
  }
</style>
